import styled from 'styled-components';
import colors, { colorWithOpacity } from '../../helpers/colors';
import fonts from '../../helpers/fonts';
import mediaQuery from '../../helpers/mediaQuery';
import spacing from '../../helpers/spacing';

export const CountdownClockContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  padding: ${spacing(3)};
  gap: ${spacing(4)};
  border: 1px solid ${colorWithOpacity(colors.core01, 0.2)};
  background: ${colorWithOpacity(colors.core01, 0.1)};
  margin: 0 auto;
  width: 100%;

  ${mediaQuery.tabletPortrait`
    padding: ${spacing(4)} ${spacing(8)}; 
    width: 96.667%;
    gap: ${spacing(6)}; 
    margin: 0 auto ${spacing(3.5)}; 
  `}

  ${mediaQuery.tabletLandscape`
      width: 93.334%;
      gap: ${spacing(8)};
  `}
`;

export const Heading = styled.span`
  ${fonts.headingSmall};
  & {
    font-size: 32px;
    font-weight: 700;
  }
  color: ${colors.core02};
  line-height: 40px;
  text-align: center;
`;

export const ClockItemsContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: ${spacing(3.5)};

  ${mediaQuery.tabletPortrait`
    flex-direction: row;
    gap: calc(3.33333vw + 4px);
  `}

  ${mediaQuery.tabletLandscape`
    gap: ${spacing(4)};
  `}
`;

export const ClockItem = styled.div`
  width: 106px;
  height: 130px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${spacing(0.75)};
`;

export const NumberBox = styled.div`
  ${fonts.headingLarge};

  & {
    font-size: 52px;
    font-weight: 700;
  }

  width: 106px;
  height: 92px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid ${colors.core02};
  background: white;
  border-radius: 15px;
  color: ${colors.core02};
`;

export const Label = styled.span`
  ${fonts.paragraphSmall};

  & {
    font-weight: 500;
    line-height: ${spacing(4)};
    font-style: normal;
  }

  color: ${colors.neutral01};
`;
